import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import axiosInstance from "../../../../services/axios-client"

const useRoleForm = () => {
    const navigate = useNavigate()
    const [isSaving, setIsSaving] = useState(false)
    const [payload, setPayload] = useState({
        ID: '',
        Name: '',
        Description: ''
    })

    const onChangeHandler= (e)=>{
        setPayload({...payload,[e.target.name]:e.target.value})
    }

    const postRoleForm = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.post('/auth/roles', payload)
            if (res.status===200) {
                navigate(-1)
                toast.success("Success Create Role")
            }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }

    const putRoleForm = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.put('/auth/roles', payload)
            if (res.status===200) {
                navigate(-1)
                toast.success("Success Update Role")
            }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }

    const getRoleForm = async(id) => {
        try {
            let res = await axiosInstance.get(`/auth/roles/id/${id}`)
            if (res.status===200) {
                setPayload(res.data.data)
            }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        }
    }

    return{
        payload,
        onChangeHandler,
        postRoleForm,
        putRoleForm,
        isSaving,
        getRoleForm
    }
}

export default useRoleForm